<template lang="pug">
v-select(
  :items="timezones"
)
</template>

<script>
export default {
  data() {
    return {
      timezones: [],
    };
  },
};
</script>

<style>

</style>
